const apiHost = process.env.REACT_APP_API_HOST;
const apiBasePath = process.env.REACT_APP_API_BASE_PATH;

const isDev = process.env.NODE_ENV === "development";

// Ensure proper URL formatting with slash between host and base path
const normalizedHost = apiHost?.replace(/\/$/, '') || ''; // Remove trailing slash
const normalizedBasePath = apiBasePath?.replace(/^\//, '') || ''; // Remove leading slash
const apiUrl = `http${isDev ? "" : "s"}://${normalizedHost}/${normalizedBasePath}`;
const socketUrl = `http${isDev ? "" : "s"}://${normalizedHost}`;

export const API = {
  endpoint: apiUrl,
  socketUrl,
};
